module.exports = __webpack_public_path__ + "assets/img/discernment_cid_scene2.56e028ff.png";